import { render, staticRenderFns } from "./simOpenSj.vue?vue&type=template&id=be282c4e&scoped=true&"
import script from "./simOpenSj.vue?vue&type=script&lang=js&"
export * from "./simOpenSj.vue?vue&type=script&lang=js&"
import style0 from "./simOpenSj.vue?vue&type=style&index=0&id=be282c4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be282c4e",
  null
  
)

export default component.exports